export default __webpack_public_path__ + "static/media/beer.1455060f.png";